import baseline from './generated/build58.json';
export default baseline;

// Resolve style arrays in native order, including font-family weights that CSS cannot infer.
export function appTextStyle(...layers) {
  const result = {};
  for (const layer of layers) {
    for (const [key, value] of Object.entries(layer || {})) {
      if (key === 'fontFamily') {
        result.fontFamily = 'Pretendard, sans-serif';
        result.fontWeight = value.endsWith('SemiBold') ? 600 : value.endsWith('Medium') ? 500 : 400;
      } else if (
        ['fontSize', 'lineHeight', 'letterSpacing', 'fontWeight', 'color', 'textAlign'].includes(
          key,
        )
      ) {
        result[key] = key === 'lineHeight' ? `${value}px` : value;
      }
    }
  }
  return result;
}
export function formatAppCount(count, locale) {
  return new Intl.NumberFormat(locale === 'en' ? 'en-US' : 'ko-KR', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(count);
}
export function playlistText(locale, key, params = {}, compact = false) {
  return appCopy(locale, `playlist.explore.${key}`, params, compact);
}
export function appCopy(locale, fullKey, params = {}, compact = false) {
  const language = locale === 'en' ? 'en' : 'ko';
  const count = params.count;
  let template = baseline.copy[language][fullKey];
  if (language === 'en' && Number(count) === 1)
    template = baseline.copy.enSingular[fullKey] || template;
  if (!template) throw new Error(`Unmapped build58 playlist copy: ${fullKey}`);
  return template.replace(/\{\{(\w+)\}\}/g, (_, name) => {
    if (params[name] === undefined) throw new Error(`Missing ${name}: ${fullKey}`);
    return compact && typeof params[name] === 'number'
      ? formatAppCount(params[name], locale)
      : String(params[name]);
  });
}
